import { CalEventFieldType } from '../constants/cal-event-field-type.js';
import { CORE_FIELD_ID_SET } from './rule-types.js';
const ACTOR_CAPABLE_FIELD_TYPES = new Set([
    CalEventFieldType.ENTITY_REF,
]);
/** Whether DEFAULT_TO_ACTOR ("whoever submits the form") is meaningful for this field — only an ENTITY_REF whose config, when supplied, references sysUser. */
export function isActorCapableField(fieldId, fields) {
    if (CORE_FIELD_ID_SET.has(fieldId))
        return false;
    const field = fields.find((candidate) => candidate.id === fieldId);
    if (field === undefined || !ACTOR_CAPABLE_FIELD_TYPES.has(field.type))
        return false;
    return field.config === undefined || field.config.entity === 'sysUser';
}
//# sourceMappingURL=is-actor-capable-field.js.map